import {
  HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Logout } from '@app/auth/actions/auth';
import * as fromAuth from '@app/auth/reducers';
import * as fromRoot from '@app/reducer';
import { unauthorizedOrForbidden } from '@app/util';
import { select, Store } from '@ngrx/store';
import {Observable,throwError as observableThrowError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';

/**
 * Intercepts the responses and redirects the user in case of 401 or 403 status code.
 * */
@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  constructor(private store: Store<fromRoot.State>) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(catchError(error => this.store.pipe(
      select(fromAuth.getLoggedIn),
      tap(loggedIn => {
        if (loggedIn && error instanceof HttpErrorResponse && unauthorizedOrForbidden(error.status)) {
          this.store.dispatch(new Logout());
        }
      }),
      switchMap(() => observableThrowError(error))
    )));
  }

}
